import Echo from 'laravel-echo';

import {BehaviorSubject, map, Observable, tap} from "rxjs";

import {HttpClient} from "@angular/common/http";
import {inject, Injectable} from "@angular/core";
import {UserNotificationService} from "./user-notification.service";
import {PushNotifService} from "./push-notif.service";
@Injectable({
  providedIn: 'root'
})
export class EchoChannelService {
   notif = inject( PushNotifService)
  notifications = inject(UserNotificationService)
  InsterSubscriptions = new BehaviorSubject<any>(null)
  subjectBan = new BehaviorSubject<any>([]);
  subjectSplash = new BehaviorSubject<any>(null);
  interest : any[] = []
  subtoken = new BehaviorSubject<any>([])
   banners:any[] = [];
 splash :any[]=[]
 qst :any[]=[]
 qstsub = new BehaviorSubject<any>([])

  constructor(private http : HttpClient) {
    this.subtoken.next(this.InsterSubscriptions.value)
  }


  rmBanner(banner: any): void {
    this.notifications.readNotif({ notifications: [banner]}).subscribe((res :any) => { return});
  }
  rmSpash(Spash :any  ){

  if(this.splash.length!==0) this.splash = this.splash.filter(data => data.id !== Spash.id); this.subjectSplash.next(this.splash);

    this.notifications.readNotif({ notifications: [Spash.id]}).subscribe((res :any) => { return});
  }
  getInterests(): Observable<any>{
    return this.http.get('/api/notification/v1/set/push/getInterests').pipe(
      map((data:any)=>data),
      tap((res :any)=> {
      //  console.log(res.data)
      const echoLara = new Echo({
        broadcaster: 'pusher',
        key: '96772aefc64a791eff9c',
        forceTLS: true,
        cluster : 'eu'
      });
      this.InsterSubscriptions.next(res.data);
      this.interest.push(res.data)
      this.notif.Start(res.data)
      res.data.map((data :any)=>{
        echoLara.channel('channel-'+data).listen('SendNotif', (e: any) => {
          // console.log('Send',e)
          this.notifications.getNotif(e.data.id).subscribe((res :any) => {
            console.log('(te',res)
            if(res.data.type ==="BANNER"){
              const  existingIndex = this.banners.findIndex((b) => b.id ===res.data.id)
             if(existingIndex === -1) {
              this.banners.push(res.data);
              this.subjectBan.next(this.banners);
              }
            }if(res.data.type ==="SPLASH"){
              const existingIndexs =  this.splash.findIndex((b) => b.id ===res.data.id)
              if(existingIndexs=== -1){
              this.splash.push(res.data);
              this.subjectSplash.next(this.splash);
              }
            }if(res.data.type ==="QUESTION"){
              const existingIndexs =  this.qst.findIndex((b) => b.id ===res.data.id)
              if(existingIndexs=== -1){
                this.qst.push(res.data);
                this.qstsub.next(this.splash);
              }
            }
            return res
          })

        });
      })
    }))
  }
}
